import { RENTAL_PORTAL_LISTING_STATUS } from '../../../../../constants/rentalPortal'
import {
  LISTING_TRANSITION,
  LISTING_TRANSITION_REASON,
} from '../../../../RentalPortalListing'

export const QA_NAME_LISTING_PROFILE_STATUS_SELECT =
  'listingProfileStatusSelect'

export const LISTING_STATUS_TRANSITION_TARGETS = [
  RENTAL_PORTAL_LISTING_STATUS.deactivated,
]

export const LISTING_STATUS_TRANSITION_KEY = {
  [RENTAL_PORTAL_LISTING_STATUS.deactivated]: LISTING_TRANSITION.deactivate,
}

export const LISTING_STATUS_TRANSITION_REASON_TOOLTIP_KEY = {
  [LISTING_TRANSITION_REASON.wrongStatus]:
    'RentalPortal.ListingDeactivateOnlyPublishedTooltipKey',
}

export const LISTING_STATUS_CHANGE_BUTTON_KEY = {
  [RENTAL_PORTAL_LISTING_STATUS.deactivated]:
    'RentalPortal.ListingDeactivateBtnKey',
  [RENTAL_PORTAL_LISTING_STATUS.published]:
    'RentalPortal.ListingActivateBtnKey',
}

export const LISTING_STATUS_CHANGE_NOTIFICATION_KEY = {
  [RENTAL_PORTAL_LISTING_STATUS.deactivated]:
    'RentalPortal.ListingDeactivatedNotificationKey',
  [RENTAL_PORTAL_LISTING_STATUS.published]:
    'RentalPortal.ListingActivatedNotificationKey',
}
